__turbopack_context__.v({
  "buttons": "LogoutModal-module__ISzXKW__buttons",
  "content": "LogoutModal-module__ISzXKW__content",
  "logoutWrapper": "LogoutModal-module__ISzXKW__logoutWrapper",
});
